interface FlightResult {
    flightSummary: { carrier: string }[];
    layovers: any[];
    totalFare: number;
  }
  
  interface MatrixResult {
    noOfStopsMatrix: Record<string, Record<string, number | "-">>;
    carrierMatrix: Record<string, Record<string, number | "-">>;
    carrierheading: string[];
    minPriceByAirlinesMatrix: Record<string, number>;
  }
  
  export function buildFlightPriceMatrix(results: FlightResult[]): MatrixResult {
    const carriersSet = new Set<string>();
    const stopsSet = new Set<string>();
    const minPriceByAirlinesMatrix: Record<string, number> = {};
  
    results.forEach((result) => {
      const carrier = result.flightSummary[0]?.carrier;
      const stops = (result.layovers?.length || 0).toString();
  
      if (carrier) {
        carriersSet.add(carrier);
        stopsSet.add(stops);
  
        if (
          minPriceByAirlinesMatrix[carrier] === undefined ||
          result.totalFare < minPriceByAirlinesMatrix[carrier]
        ) {
          minPriceByAirlinesMatrix[carrier] = result.totalFare;
        }
      }
    });
  
    const carriers = Array.from(carriersSet).sort((a, b) => {
      const priceA = minPriceByAirlinesMatrix[a] ?? Infinity;
      const priceB = minPriceByAirlinesMatrix[b] ?? Infinity;
      return priceA - priceB;
    });
    
    const stops = Array.from(stopsSet).sort();
  

    const noOfStopsMatrix: Record<string, Record<string, number | "-">> = {};
    const carrierMatrix: Record<string, Record<string, number | "-">> = {};
  

    stops.forEach((stop) => {
      noOfStopsMatrix[stop] = {};
      carriers.forEach((carrier) => {
        noOfStopsMatrix[stop][carrier] = "-";
      });
    });
    carriers.forEach((carrier) => {
      carrierMatrix[carrier] = {};
      stops.forEach((stop) => {
        carrierMatrix[carrier][stop] = "-";
      });
    });
  

    results.forEach((result) => {
      const carrier = result.flightSummary[0]?.carrier;
      const stops = (result.layovers?.length || 0).toString();
      const fare = result.totalFare;
  
      if (carrier && stops) {
       
        if (
          noOfStopsMatrix[stops][carrier] === "-" ||
          fare < (noOfStopsMatrix[stops][carrier] as number)
        ) {
          noOfStopsMatrix[stops][carrier] = fare;
          carrierMatrix[carrier][stops] = fare;
        }
      }
    });
  
    return {
      noOfStopsMatrix,
      carrierMatrix,
      carrierheading: carriers,
      minPriceByAirlinesMatrix,
    };
  }